// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.is-category-count[data-v-5bd474ab]{margin-left:auto;font-size:10px;opacity:.65;flex-shrink:0}.is-sidebar-item span[data-v-5bd474ab]:first-of-type{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}\n", ""]);
// Exports
module.exports = exports;
